(() => {
  if (customElements.get('lazuela-premium')) return;
  class LazuelaPremium extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.pendingObserver) return;
      // A cached script can register the element before the HTML parser has
      // finished its children. Wait for the footer so all panels exist.
      if (!this.querySelector('.lzpe-footer')) {
        this.pendingObserver = new MutationObserver(() => {
          if (!this.querySelector('.lzpe-footer')) return;
          this.pendingObserver.disconnect();
          this.pendingObserver = null;
          this.connectedCallback();
        });
        this.pendingObserver.observe(this, { childList: true, subtree: true });
        return;
      }
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = [...this.querySelectorAll('[data-lzpe-tab]')];
      this.panels = [...this.querySelectorAll('[data-lzpe-panel]')];
      this.querySelector('[data-lzpe-tabs]')?.setAttribute('role', 'tablist');
      this.panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', () => this.activate(tab), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.activate(this.tabs[next]);
          this.tabs[next].focus();
        }, options);
      });
      this.activate(this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this.tabs[0]);
      document.addEventListener('shopify:block:select', event => {
        let target = event.target instanceof Element && this.contains(event.target) ? event.target : null;
        if (!target?.closest('[data-lzpe-panel]')) {
          const blockId = String(event.detail?.blockId || '');
          target = [...this.querySelectorAll('[data-shopify-editor-block]')].find(element => {
            try { return JSON.parse(element.getAttribute('data-shopify-editor-block')).id === blockId; }
            catch { return false; }
          }) || target;
        }
        if (!target || !this.contains(target)) return;
        const panel = target.closest('[data-lzpe-panel]');
        if (panel) this.activate(this.tabs.find(tab => tab.dataset.lzpeTab === panel.dataset.lzpePanel));
        const details = target.closest('details');
        if (details) details.open = true;
      }, options);
    }
    activate(selected) {
      if (!selected) return;
      this.tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.lzpePanel !== selected.dataset.lzpeTab; });
    }
    disconnectedCallback() {
      this.pendingObserver?.disconnect();
      this.pendingObserver = null;
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('lazuela-premium', LazuelaPremium);
})();
